export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOADING = 'LOADING';
export const UPDATE_STATE_SELLER_ACCOUNT = 'UPDATE_STATE_SELLER_ACCOUNT';

export const GET_SESSION_ME = 'GET_SESSION_ME';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
